import moment from 'moment';

export class DateFormatter {
  format(date: Date, format: string, locale: string): string {
    return moment(date.getTime()).format(format);
  }
}
